import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions, fetchActions } from './';
import { history } from '../_helpers';

export const userActions = {
    login,
    logout,
    reset,
    register,
    getAll,
    delete: _delete
};

function login(username, password) {
    return dispatch => {
        dispatch(request({ username }));
        dispatch(fetchActions.start())
        userService.login(username, password)
            .then( user => {
                console.log(user);
                return user
            })
            .then(
                user => { 
                    localStorage.setItem('reports', JSON.stringify(user.reports));
                    dispatch(success(user));
                    dispatch(fetchActions.success())
                    history.push('/');
                },
                error => {
                    dispatch(failure(error));
                    dispatch(fetchActions.error())
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout()
    return dispatch => {
        dispatch(success());
    };
    function success() { return { type: userConstants.LOGOUT } }
}

function reset (username) {
    return dispatch => {
        dispatch(request({ username }));
        dispatch(fetchActions.start())
        userService.login(username)
            .then(
                user => { 
                    dispatch(success(user));
                    dispatch(fetchActions.success())
                    history.push('/');
                },
                error => {
                    dispatch(failure(error));
                    dispatch(fetchActions.error())
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.RESET_REQUEST, user } }
    function success(user) { return { type: userConstants.RESET_SUCCESS, user } }
    function failure(error) { return { type: userConstants.RESET_FAILURE, error } }
}

function register(user) {
    return dispatch => {
        dispatch(request(user));

        userService.register(user)
            .then(
                user => { 
                    dispatch(success());
                    history.push('/login');
                    dispatch(alertActions.success('Registration successful'));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
    function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function getAll() {
    return dispatch => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        userService.delete(id)
            .then(
                user => { 
                    dispatch(success(id));
                },
                error => {
                    dispatch(failure(id, error));
                }
            );
    };

    function request(id) { return { type: userConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: userConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: userConstants.DELETE_FAILURE, id, error } }
}